import { render, staticRenderFns } from "./cardItemNew.vue?vue&type=template&id=f39f7240"
import script from "./cardItemNew.vue?vue&type=script&lang=js"
export * from "./cardItemNew.vue?vue&type=script&lang=js"
import style0 from "./cardItemNew.vue?vue&type=style&index=0&id=f39f7240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports